import axios from 'axios'
import constants from '../../config'
import Form from '../../plugins/Form';
import {dash} from "../../utils/componentHelper.js";

let emptyForm = new Form({})

const state = {
  campaignData: {},
  campaignDonationData: {},

  storeInformationStatus: {},
  storeInformationErrors: {},

  payouts: {},
  payoutStatus: {},
  payoutErrors: {},

  saveAsDraftData: {},
}

// getters
const getters = {
  campaignData: (state) => campaignSlug => {
    let slug = campaignSlug
    if (_.isEmpty(slug)) {
      slug = 'create'
    }

    let data = state.campaignData[slug]
    if (data == null) {
      return null
    }

    return data
  },

  campaignDonationData: (state) => campaignSlug => {
    let data = state.campaignDonationData[campaignSlug]

    if (data == null) {
      return null
    }

    return data
  },

  payouts: (state) => campaignSlug => {
    let data = state.payouts[campaignSlug]

    if (data == null) {
      return null
    }

    return data
  },

  payoutStatus: (state) => (campaignSlug) => {
    let data = state.payoutStatus[campaignSlug]

    if (data == null) {
      return null
    }

    return data.status
  },

  payoutErrors: (state) => (campaignSlug) => {
    let data = state.payoutErrors[campaignSlug]

    if (data == null) {
      return emptyForm.errors
    }

    return data.errors
  },

  storeInformationData: (state) => (campaignSlug, informationType) => {
    let slug = campaignSlug
    if (_.isEmpty(slug)) {
      slug = 'create'
    }

    let data = state.storeInformationStatus[slug]

    if (data == null) {
      return null
    }

    data = data[informationType]

    if (data == null) {
      return null
    }

    return data.respData
  },

  storeInformationStatus: (state) => (campaignSlug, informationType) => {
    let slug = campaignSlug
    if (_.isEmpty(slug)) {
      slug = 'create'
    }

    let data = state.storeInformationStatus[slug]

    if (data == null) {
      return null
    }

    data = data[informationType]

    if (data == null) {
      return null
    }

    return data.status
  },

  storeInformationErrors: (state) => (campaignSlug, informationType) => {
    let slug = campaignSlug
    if (_.isEmpty(slug)) {
      slug = 'create'
    }

    let data = state.storeInformationErrors[slug]

    if (data == null) {
      return emptyForm.errors
    }

    data = data[informationType]

    if (data == null) {
      return emptyForm.errors
    }

    return data.errors
  },

  saveAsDraftData: (state) => campaignSlug => {
    let data = state.saveAsDraftData[campaignSlug]
    if (data == null) {
      return null
    }

    return data
  },
}

// actions
const actions = {

  fetchData ({commit}, campaignSlug) {
    let endpoint = `${constants.BASE_URL}campaign/data/`
    let stateKey = campaignSlug

    if (campaignSlug != null) {
      endpoint += campaignSlug
    } else {
      stateKey = 'create'
    }

    return axios.get(endpoint)
      .then(function (resp) {
        resp.data.campaignSlug = stateKey
        commit('setCampaignData', resp.data)
      })
      .catch(function (resp) {
        console.log('Campaign data could not be found', resp)
      })
  },

  fetchDonationData ({commit}, campaignSlug) {
    return axios.get(constants.BASE_URL + `donation/${campaignSlug}`)
      .then(function (resp) {
        resp.data.campaignSlug = campaignSlug

        commit('setCampaignDonationData', resp.data)
      })
      .catch(function (resp) {
        console.log('Campaign donation data could not be found', resp)
      })
  },

  fetchPayouts ({commit}, data) {
    let nextPage = data.current_page + 1

    return axios.get(constants.BASE_URL + `campaign/payouts/${data.campaignSlug}/?page=${nextPage}`)
      .then(function (resp) {
        resp.data.campaignSlug = data.campaignSlug
        commit('setPayouts', resp.data)
      })
      .catch(function (resp) {
        console.log('Campaign payout data could not be found', resp)
      })
  },

  makePayout({commit, state}, formData) {
    let form = new Form(formData)
    let requestType = 'post'

    return form.submit(requestType, constants.BASE_URL + `campaign/make-payout/${formData.campaignSlug}`)
      .then((resp) => {
        commit('setPayoutStatus', {
          campaignSlug: formData.campaignSlug,
          status: 'success',
          respData: resp.data
        })
        commit('setPayoutErrors', {'errors': form.errors, campaignSlug: formData.campaignSlug})
      })
      .catch((resp) => {
        commit('setPayoutStatus', {'status': 'failed', campaignSlug: formData.campaignSlug,})

        if (form.errors.any()) {
          commit('setPayoutErrors', {'errors': form.errors, campaignSlug: formData.campaignSlug,})
        } else {
          let internalError = {internalError: true}

          form.errors.record(internalError)
          commit('setPayoutErrors', {'errors': form.errors, campaignSlug: formData.campaignSlug,})
        }
      })
  },

  storeInformation({commit, state}, formData) {
    let form = new Form(formData)
    let endpoint = `${constants.BASE_URL}campaign/`
    let stateKey = formData.campaignSlug

    if (formData.campaignSlug != null) {
      endpoint += `${formData.informationType}/${dash(formData.campaignSlug)}`
    } else {
      endpoint += `create`
      stateKey = `create`
    }

    return form.submit(formData.method, endpoint, formData.withFiles)
      .then((resp) => {
        commit('setStoreInformationStatus', {
          campaignSlug: stateKey,
          informationType: formData.informationType,
          status: 'success',
          respData: resp.data
        })
        commit('setStoreInformationErrors', {
          campaignSlug: stateKey,
          informationType: formData.informationType,
          errors: form.errors
        })
      })
      .catch((resp) => {
        commit('setStoreInformationStatus', {
          campaignSlug: stateKey,
          informationType: formData.informationType,
          status: 'failed',
        })

        if (form.errors.any()) {
          commit('setStoreInformationErrors', {
            campaignSlug: stateKey,
            informationType: formData.informationType,
            errors: form.errors,
          })
        } else {
          let internalError = {internalError: true}

          form.errors.record(internalError)
          commit('setStoreInformationErrors', {
            campaignSlug: stateKey,
            informationType: formData.informationType,
            errors: form.errors,
          })
        }
      })
  },

  saveAsDraft({commit, state}, campaignSlug) {
    let form = new Form({
      status: 'draft'
    })
    let endpoint = `${constants.BASE_URL}campaign/campaign-status/${campaignSlug}`

    return form.submit('put', endpoint, false)
      .then((resp) => {
        commit('saveAsDraftData', {
          campaignSlug: campaignSlug,
          status: 'success',
          respData: resp.data
        })
      })
      .catch((resp) => {
        commit('saveAsDraftData', {
          campaignSlug: campaignSlug,
          status: 'failed',
          respData: resp.data
        })
      })
  },

  async publishCampaign({dispatch, commit}, form) {
    let endpoint = `campaign/publish-campaign/${form.campaignSlug}`
    return form.submit('post', endpoint)
  },
}


// mutations
const mutations = {
  setCampaignData (state, data) {
    state.campaignData[data.campaignSlug] = data
  },

  setCampaignDonationData (state, data) {
    state.campaignDonationData[data.campaignSlug] = data
  },

  setStoreInformationStatus (state, data) {
    if (_.isEmpty(state.storeInformationStatus[data.campaignSlug])) {
      state.storeInformationStatus[data.campaignSlug] = {}
    }
    state.storeInformationStatus[data.campaignSlug][data.informationType] = data
  },

  setStoreInformationErrors (state, data) {
    if (_.isEmpty(state.storeInformationErrors[data.campaignSlug])) {
      state.storeInformationErrors[data.campaignSlug] = {}
    }
    state.storeInformationErrors[data.campaignSlug][data.informationType] = data
  },

  setPayouts (state, data) {
    state.payouts[data.campaignSlug] = data
  },

  setPayoutStatus (state, data) {
    state.payoutStatus[data.campaignSlug] = data
  },

  setPayoutErrors (state, data) {
    state.payoutErrors[data.campaignSlug] = data
  },

  saveAsDraftData (state, data) {
    state.saveAsDraftData[data.campaignSlug] = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}